import { render } from "./PostTypeSelector.vue?vue&type=template&id=b4f78b3e"
import script from "./PostTypeSelector.vue?vue&type=script&lang=js"
export * from "./PostTypeSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/PostTypeSelector.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b4f78b3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b4f78b3e', __exports__)) {
    api.reload('b4f78b3e', __exports__)
  }
  
  module.hot.accept("./PostTypeSelector.vue?vue&type=template&id=b4f78b3e", () => {
    api.rerender('b4f78b3e', render)
  })

}


export default __exports__